import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useAppStoreSelector } from '../../store';
import styles from './Admin.module.scss';
import { Link, Outlet } from 'react-router-dom';

function Admin() {
  const adminState = useAppStoreSelector((state) => state.admin);
  return (
    <Box className={styles['admin-container']}>
      <Box component="nav" className={styles['admin-nav']}>
        {adminState.data.selectedUsers.map((selectedUser, index) => (
          <Link
            to={index === 0 ? '/admin' : `/admin/user/${selectedUser}`}
            key={index}
            style={{ textDecoration: 'none' }}
          >
            <Button variant="outlined" color="primary">{selectedUser}</Button>
          </Link>
        ))}
      </Box>
      <Box>
        <Outlet />
      </Box>
    </Box>
  );
}

export default Admin;
